import { createContext } from 'react';

// { page, setPage, nav?, goSettings } — fourni par App.js autour des pages. Dans son propre fichier : un écran qui
// ne veut que changer de page (un montant qui mène à Opérations spéciales) n'a pas à charger tout le menu.
export const ReportNavContext = createContext(null);
